import { FormDefinition, FormElementType } from "~/api";

export function getNewQuestionCode(
  form: FormDefinition,
  questionType: FormElementType,
): string {
  const codeNumber =
    form.components.filter((c) => c.type === questionType).length + 1;

  return `${questionType}${codeNumber}`;
}
